export default __webpack_public_path__ + "static/media/background.b448862e.png";